import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { recoverPetLog } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import replayPetData from "./components/replayPetData.vue";
export default {
  name: "petPeply",
  components: {
    replayPetData: replayPetData
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      currentPage: 1,
      tableData: [],
      total: 0,
      exportLoading: false,
      paramsData: {
        player_id: "",
        pet_id: ""
      }
    };
  },
  created: function created() {// this.getList(1);
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.page = e;
                _this.reqLoading = true;
                recoverPetLog(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this.tableData = res.data.data;
                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchDara: function searchDara() {
      this.$refs.replayPetData.open();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var columns, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                columns = [{
                  label: _this2.$t('operator'),
                  prop: 'nickname'
                }, {
                  label: _this2.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this2.$t('petId'),
                  prop: 'pet_id'
                }, {
                  label: _this2.$t('operationTime'),
                  prop: 'exc_time'
                }];
                data = _this2.tableData;

                _this2.$export.excel({
                  columns: columns,
                  data: data,
                  title: _this2.$route.meta.title
                });

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};